export const ROUTES = {
	MYPROFILE: "/",
	CHURN: "/churn",
	REVENUE: "/revenue",
	WASHREDEMPTION: "/wash-redemption",
	MEMBERSHIPSNAPSHOT: "/membership-snapshot",
	MEMBERSHIPTIMELINE: "/membership-timeline",
	MEMBERSHIPROFILES: "/membership-profiles",
	MARKETING: "/marketing",
	RETAIL: "/retail",
	LEADERBOARDS: "/leaderboards/:brand",
	TICKETING: "/ticketing",
	TICKETVIEW: "/tickets/:id",
	EMPLOYEE_LEADERBOARDS: "/employee-leaderboards",
	SITE_LEADERBOARDS: "/site-leaderboards",
	REGIONAL_TARGETS: "/regional-targets",
};
